<template>
  <div>
    <SettingsNavigation />

    <div class="max-w-screen-xl mx-auto px-6">
      <ExportCard />
    </div>
  </div>
</template>

<script>
import SettingsNavigation from '@components/Settings/SettingsNavigation'
import ExportCard from '@components/Settings/Export/ExportCard'

export default {
  components: {
    SettingsNavigation,
    ExportCard
  }
}
</script>
